import * as UI from "@iyk/ui"

import { Branded } from "./branded.tsx"
import { SectionLayout } from "./ui/section-layout.tsx"

export const PoweredByIYK = ({ ...props }: UI.HTMLElementProps) => (
  <SectionLayout size="fluid" theme="dark" {...props}>
    <div className="flex flex-col gap-12 items-center bg-white text-gray-12-light rounded-lg pb-12 text-sm text-center">
      <div className="max-w-96 flex flex-col items-center gap-4 px-6 [padding-block:6.5rem]">
        <img
          src="https://assets.iyk-dev.app/postcards/iyk.svg"
          alt=""
          width="28"
          height="28"
          className="size-7"
        />
        <h3 className="text-xs-upper">
          This product is powered by <Branded with="*">IYK</Branded>
        </h3>
        <p className="text-balance">
          IYK offers a toolkit that bridges digital experiences with physical spaces and objects
          through NFC technology. IYK’s custom chips and no-code tools enable seamless integrations
          for a diverse range of clients.
        </p>
        <p>
          <a
            href="https://iyk.app/"
            target="_blank"
            className="inline-block leading-5 bshadow-b bshadow-gray-7-light"
          >
            Learn more
          </a>
        </p>
      </div>
      <UI.Marquee className="w-full h-10 contain-size" aria-hidden="true">
        <img
          src="https://assets.iyk-dev.app/postcards/powered_by_iyk/powered_by_iyk-sony_music.svg"
          alt="Sony Music"
          width="162"
          height="14"
          loading="lazy"
          className="shrink-0 w-[160px] h-10"
        />
        <img
          src="https://assets.iyk-dev.app/postcards/powered_by_iyk/powered_by_iyk-coinbase.svg"
          alt="Coinbase"
          width="115"
          height="22"
          loading="lazy"
          className="shrink-0 w-[112px]"
        />
        <img
          src="https://assets.iyk-dev.app/postcards/powered_by_iyk/powered_by_iyk-complexcon.svg"
          alt="ComplexCon"
          width="115"
          height="22"
          loading="lazy"
          className="shrink-0 w-[120px] h-10"
        />
        <img
          src="https://assets.iyk-dev.app/postcards/powered_by_iyk/powered_by_iyk-mastercard.svg"
          alt="Mastercard"
          width="53"
          height="40"
          loading="lazy"
          className="shrink-0 w-[52px] h-10"
        />
        <img
          src="https://assets.iyk-dev.app/postcards/powered_by_iyk/powered_by_iyk-adidas.svg"
          alt="Adidas"
          width="60"
          height="40"
          loading="lazy"
          className="shrink-0 w-[60px] h-10"
        />
        <img
          src="https://assets.iyk-dev.app/postcards/powered_by_iyk/powered_by_iyk-atlantic.svg"
          alt="Atlantic"
          width="64"
          height="40"
          loading="lazy"
          className="shrink-0 w-[64px] h-10"
        />
        <img
          src="https://assets.iyk-dev.app/postcards/powered_by_iyk/powered_by_iyk-macys.svg"
          alt="Macy's"
          width="100"
          height="30"
          loading="lazy"
          className="shrink-0 w-[132px] h-10"
        />
        <img
          src="https://assets.iyk-dev.app/postcards/powered_by_iyk/powered_by_iyk-billionaire_boys_club.svg"
          alt="Billionaire Boys Club"
          width="61"
          height="40"
          loading="lazy"
          className="shrink-0 w-[60px] h-10"
        />
        <img
          src="https://assets.iyk-dev.app/postcards/powered_by_iyk/powered_by_iyk-johnnie_walker.svg"
          alt="Johnnie Walker"
          width="190"
          height="30"
          loading="lazy"
          className="shrink-0 w-[188px] h-10"
        />
      </UI.Marquee>
    </div>
  </SectionLayout>
)
